import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function usePick(setGames) {
  const [saving, setSaving] = useState(null);
  const pick = async (game, side) => {
    if (game.locked) return;
    const clear = game.my_pick === side;
    setSaving(game.id);
    try {
      if (clear) await api.delete(`/predictions/${game.id}`, { params: { league_id: game.league_id } });
      else await api.put(`/predictions/${game.id}`, { pick: side, league_id: game.league_id });
      setGames((list) => list.map((g) => (g.id === game.id ? { ...g, my_pick: clear ? null : side } : g)));
      toast.success(clear ? "Pronostic retiré" : `Prédiction enregistrée : ${game[side].name}`);
    } catch (e) {
      toast.error(errMsg(e));
      if (e.response?.status === 409) setGames((list) => list.map((g) => (g.id === game.id ? { ...g, locked: true } : g)));
    } finally {
      setSaving(null);
    }
  };
  return { pick, saving };
}

export const copyMsg = (d) => {
  const n = d.copied + d.bonus;
  if (!n) return "Rien à copier : aucune autre ligue n'a ce match ouvert";
  const parts = [d.copied && `${d.copied} prono${d.copied > 1 ? "s" : ""}`, d.bonus && `${d.bonus} réponse${d.bonus > 1 ? "s" : ""} bonus`].filter(Boolean).join(" et ");
  const fem = !d.copied;
  return `${parts} copié${fem ? "e" : ""}${n > 1 ? "s" : ""} dans ${d.leagues} autre${d.leagues > 1 ? "s" : ""} ligue${d.leagues > 1 ? "s" : ""}`;
};

export async function copyPicks(fromLeagueId, gameIds) {
  try {
    const { data } = await api.post("/predictions/copy", { from_league_id: fromLeagueId, game_ids: gameIds });
    toast.success(copyMsg(data));
    return data;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}
